import { createSlice } from "@reduxjs/toolkit";
import { getCCFPoints } from "./thunk";


const getCCFPointsSlice = createSlice({
    name: "getCCFPoints",
    initialState: {
        isLoading: false,
        isError: false,
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(getCCFPoints.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(getCCFPoints.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(getCCFPoints.rejected, (state) => {
            state.isError = true;
            state.isLoading = false;
        });
    }
});

export default getCCFPointsSlice.reducer;